/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type TasksCategoriesTemplatesListFreightMethod = typeof TasksCategoriesTemplatesListFreightMethod[keyof typeof TasksCategoriesTemplatesListFreightMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TasksCategoriesTemplatesListFreightMethod = {
  AIR: 'AIR',
  OCEAN: 'OCEAN',
} as const;
